import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCategoriesByParentName } from "../../../helpers/common";
import CategoryBox from "./CategoryBox";
import ProductBox from "./ProductBox";

const DropdownMenuWeb = ({
  topMenus,
  categories,
  labeledProducts,
  setSubMenuVisible,
  openModal,
}) => {
  const [hideMenu, setHideMenu] = useState(false);

  useEffect(() => {
    if (hideMenu) {
      setTimeout(() => {
        setHideMenu(false);
      }, 500);
    }
  }, [hideMenu]);

  return (
    <ul className="menu-main">
      {topMenus.map((menu) => (
        <li
          key={menu.id}
          onClick={() => setSubMenuVisible(true)}
          className="menu-item-has-children"
        >
          <Link
            className="nav-link"
            to={
              menu?.url?.includes("#labels/") || menu?.url?.includes("#")
                ? "#"
                : menu.url
            }
          >
            {menu.name}
          </Link>
          {getCategoriesByParentName(categories, menu.name)?.length > 0 ||
          labeledProducts[menu.name]?.length > 0 ? (
            <div
              className="sub-menu mega-menu mega-menu-column-4"
              style={{ display: hideMenu && "none" }}
            >
              {menu.url.includes("#labels/")
                ? labeledProducts[menu.name]?.map((product, index) => (
                    <ProductBox
                      openModal={openModal}
                      key={"product-" + index}
                      product={product}
                    />
                  ))
                : getCategoriesByParentName(categories, menu.name)?.map(
                    (category, index) => (
                      <CategoryBox
                        key={"category" + index}
                        category={category}
                        onClick={() => setHideMenu(true)}
                      />
                    )
                  )}
            </div>
          ) : null}
        </li>
      ))}
    </ul>
  );
};

export default DropdownMenuWeb;
